export const ConversationalMMAnalyticsEvent = {
    ResultsRevealed: 'conversational_mm_results_revealed',
    ResultsMM: 'conversational_mm_results_mm',
    ResultsExplainer: 'conversational_mm_results_explainer',
    ResultsSystem: 'conversational_mm_results_system',
    ResultsGraph: 'conversational_mm_results_graph',
    ResultsSummary: 'conversational_mm_results_summary',
    ResultsSlideViewed: 'conversational_mm_results_slide_viewed',
    ResultsPrev: 'conversational_mm_results_prev',
    ResultsNext: 'conversational_mm_results_next',
    SlideNextButtonPressed: 'conversational_mm_slide_next_button_pressed',
    SpendGoalsSlider: 'conversational_mm_spend_goals_slider_adjusted',
    InvestContribSlider: 'conversational_mm_invest_contrib_slider_adjusted',
    InvestTimeSlider: 'conversational_mm_invest_time_slider_adjusted',
    GoalsCardsExpanded: 'conversational_mm_goals_cards_expanded',
    TooltipPressed: 'conversational_mm_tooltip_pressed',
    TooltipsSequenceDone: 'conversational_mm_tooltips_sequence_done',
} as const;

export type ConversationalMMAnalyticsEventName =
    (typeof ConversationalMMAnalyticsEvent)[keyof typeof ConversationalMMAnalyticsEvent];

export type ConversationalMMTrackEvent = (
    name: ConversationalMMAnalyticsEventName,
    payload?: Record<string, string | number | boolean>,
    options?: { sendImmediately?: boolean },
) => void;
